import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      flag:false,
      productDetailsList: [],
      id:'',
      centerHeight: document.documentElement.clientHeight - 260 +'px',
      montyTotal:0,
      successFlag: false,
      failFlag: false
    }
  },
  computed: {
    ...mapState('pointsMailCashierModule', []),
  },
  methods: {
    ...mapActions('pointsMailCashierModule', ['getPayStatus']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    async goToHomePage () {
      this.$router.push({
        path: RoutePathConstants.POINTS_MAIL_HOME_PAGE
      })
    },
    goToMyOrder () {
      this.$router.push({
        path: RoutePathConstants.MY_ORDER
      })
    },
    async getPayStatusInfo (params) {
      let res = await this.getPayStatus(params)
      if (res.code === ReturnCodesConstants.SUCCESS_CODE) {
        this.successFlag = true
      } else {
        this.failFlag = true
        this.$message.error(`支付失败！`)
      }
    }
  },
  mounted () {
    // this.payOrderNum = this.$route.query.payOrderNum
    // console.log(payOrderNum)
    this.getPayStatusInfo({payOrderNum:this.payOrderNum})
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-cashier/views/points-mail-cashier.js